import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

const SortableTableRow = ({
  children,
  id,
  disabled = false,
  showDragHandle = true,
  ...props
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
    isOver,
  } = useSortable({
    id,
    disabled
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    backgroundColor: isOver ? '#f5f5f5' : 'inherit',
    zIndex: isDragging ? 1000 : 'auto',
    position: 'relative',
    WebkitTouchCallout: 'none',
    WebkitUserSelect: 'none',
    userSelect: 'none',
  };

  return (
    <tr
      ref={setNodeRef}
      style={style}
      className={`
        ${isDragging ? 'cursor-grabbing' : 'cursor-default'}
        ${!disabled ? 'hover:bg-muted/50' : ''}
      `}
      role="row"
      aria-label={disabled ? undefined : "可拖拽的表格行"}
      tabIndex={disabled ? undefined : 0}
      {...props}
    >
      {showDragHandle && (
        <td className="w-[50px] p-2 text-center border-r border-border">
          {!disabled && (
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <div
                    {...attributes}
                    {...listeners}
                    role="button"
                    aria-label="拖拽手柄，用于重新排序此行"
                    tabIndex={0}
                    className={`
                      flex items-center justify-center
                      ${isDragging ? 'cursor-grabbing' : 'cursor-grab'}
                      opacity-70 rounded min-h-10 min-w-8
                      bg-black/5 border border-dashed border-black/20
                      transition-all duration-200
                      hover:opacity-100 hover:bg-black/10 hover:border-black/40 hover:scale-105
                      focus:opacity-100 focus:bg-black/15 focus:outline-2 focus:outline-primary focus:outline-offset-1 focus:border-primary
                      touch-none
                    `}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                      }
                    }}
                  >
                    <div className="flex flex-col gap-0.5 items-center">
                      {[1, 2, 3].map((line) => (
                        <div
                          key={line}
                          className="w-4 h-0.5 bg-muted/40 rounded transition-colors"
                        />
                      ))}
                    </div>
                  </div>
                </TooltipTrigger>
                <TooltipContent side="top">
                  <p>拖拽排序</p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )}
        </td>
      )}
      {children}
    </tr>
  );
};

export default SortableTableRow;
